import { render, staticRenderFns } from "./Guilds.vue?vue&type=template&id=7bf2fd8d&"
import script from "./Guilds.vue?vue&type=script&lang=js&"
export * from "./Guilds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports